// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__14WPI","containerItemsCenter":"Skeleton_containerItemsCenter__gnyM_"};